<template>
    <section>
        <div class="grid xs-grid-cols-1">
            <h2 class="f4 text-bold">{{molang(`search.common.nearbyRealEstate`)}}</h2>
            <mvtSeoLink :showSiteMapLinks="showSiteMapLinks" :cities="cities" :zipcodes="zipcodes" :neighborhoods="neighborhoods" :counties="counties" :maxCount="10" />
            <div class="mvt-seolink-footer" v-if="getMapSearchLinks && getMapSearchLinks.base">
                {{molang(`dpp.seo.view`)}}
                <a class="link" :href="`${getMapSearchLinks.base}${glb.rentals?'rentals/':''}`" :title="`${dpp.geo.city} ${molang(`dpp.seo.homesFor${glb.rentals ? 'Rent' : 'Sale'}`)}`">
                    {{molang(`dpp.seo.homesForSale${glb.rentLang}In`)}}
                    {{dpp.geo.city}}, {{dpp.geo.state}}
                </a>
                {{molang('dpp.seo.filteredBy')}}:<br>
                <template v-for="(item,index) in getMapSearchLinks.filterArray">
                    <span v-if="index !== 0">, </span><a class="link" :href="`${getMapSearchLinks.filteredBaseUrl}${getMapSearchLinks.filterMapper[item].url}/`">{{dpp.geo.city + ' ' + molang('search.advantage.'+item)}}</a>
                </template>.
            </div>
        </div>
    </section>
</template>
<script src="./property-seolink.js"></script>
